import _ from 'underscore';
import { BaseValidator } from './base-validator';

export class EffectKeyValidator extends BaseValidator {
  constructor(propertySchema) {
    super(propertySchema);

    this.effectKey = propertySchema.effectKey;
  }

  get requiredField() {
    return 'effectKey';
  }

  get config() {
    return {
      ignoreInvalidProperty: true,
    };
  }

  internalValidate(propertyValue, effectKey) {
    return _.contains(this.effectKey, effectKey);
  }
}
